import React, { useRef, useState, useEffect } from 'react';
import { Chip } from '@mui/material';
import MaterialSymbol from '../../../components/icons/material-symbol';
import InputEmoji from 'react-input-emoji';
import { KeywordEntry } from 'custom-type';

// type KeywordEntry = {
//   keyword: string;
//   reply: string;
// };

type ErrorMessageProps = {
  status: boolean;
  message: string;
}

type Props = {
  keywords: KeywordEntry[];
  handleSetKeywords: (keywords: KeywordEntry[]) => void;
  keywordsError: ErrorMessageProps;
  removeKeywordsError: () => void;
}

const KeywordInput = (props: Props) => {
  const [showInput, setShowInput] = useState(false);
  const [newKeyword, setNewKeyword] = useState('');
  const [newReply, setNewReply] = useState('');
  // const [keywords, setKeywords] = useState<KeywordEntry[]>([]);
  const inputWrapperRef = useRef<HTMLDivElement | null>(null);
  const [keywordError, setKeywordError] = useState('');
  const [replyError, setReplyError] = useState('');

  function handleShowInput() {
    setShowInput(true);
    props.removeKeywordsError();
  }


  // const handleClickOutside = (e: any) => {
  //   if (inputWrapperRef.current && !inputWrapperRef.current.contains(e.target)) {
  //     if (newKeyword.trim() === '' && newReply.trim() === '') {
  //       setShowInput(false);
  //     } else {
  //       handleInputSubmit();
  //     }
  //   }
  // };

  // const handleClickOutside = (e: any) => {
  //   if (inputWrapperRef.current && !inputWrapperRef.current.contains(e.target)) {
  //     if (newKeyword.trim() && newReply.trim()) {
  //       handleInputSubmit();
  //     } else {
  //       alert("Both Keyword and Reply are required.");
  //     }
  //   }
  // };

  const handleClickOutside = (e: any) => {
    if (inputWrapperRef.current && !inputWrapperRef.current.contains(e.target)) {
      handleInputSubmit(); // It will show errors if invalid
    }
  };

  // const handleInputSubmit = () => {
  //   if (newKeyword.trim() && newReply.trim()) {
  //     setKeywords([...keywords, { keyword: newKeyword.trim(), reply: newReply.trim() }]);
  //     setShowInput(false);
  //     setNewKeyword('');
  //     setNewReply('');
  //   } else {
  //     // Optionally: highlight empty fields or show alert
  //     alert("Both Keyword and Reply are required.");
  //   }
  // };

  const handleInputSubmit = () => {
    let hasError = false;

    if (!newKeyword.trim()) {
      setKeywordError('Keyword is required');
      hasError = true;
    } else {
      setKeywordError('');
    }

    if (!newReply.trim()) {
      setReplyError('Reply is required');
      hasError = true;
    } else {
      setReplyError('');
    }

    if (hasError) return;

    // If no errors, proceed
    props.handleSetKeywords([...props.keywords, { keyword: newKeyword.trim(), reply: newReply.trim() }]);
    setShowInput(false);
    setNewKeyword('');
    setNewReply('');
    setKeywordError('');
    setReplyError('');
  };

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleInputSubmit();
    }
  };

  useEffect(() => {
    if (showInput) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleKeyPress);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyPress);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [showInput, newKeyword, newReply]);

  return (
    <li>
      <span className='pb-3 d-inline-flex fs-14'>Set keywords and replies that will start your DM automation.</span>
      <div className='new-automation-chips'>
        {props.keywords.map((entry, index) => (
          <Chip
            key={index}
            label={`${entry.keyword} → ${entry.reply}`}
            onDelete={() => props.handleSetKeywords(props.keywords.filter((_, i) => i !== index))}
            className='chip-item'
          />
        ))}

        {showInput ? (
          // <div className='inline-input d-inline-flex gap-2' ref={inputWrapperRef}>
          //   <input
          //     type='text'
          //     value={newKeyword}
          //     onChange={(e) => setNewKeyword(e.target.value)}
          //     placeholder='Keyword'
          //     autoFocus
          //     className='form-control'
          //   />
          //   <input
          //     type='text'
          //     value={newReply}
          //     onChange={(e) => setNewReply(e.target.value)}
          //     placeholder='Reply'
          //     className='form-control'
          //   />
          // </div>
          <div className='inline-input d-inline-flex gap-2' ref={inputWrapperRef}>
            <div>
              <input
                type='text'
                value={newKeyword}
                onChange={(e) => {
                  setNewKeyword(e.target.value);
                  if (e.target.value.trim()) setKeywordError('');
                }}
                placeholder='Keyword'
                autoFocus
                className='form-control'
              />
              {keywordError && <small className='text-danger'>{keywordError}</small>}
            </div>
            <div className="w-100">
              <InputEmoji
                value={newReply}
                onChange={(val) => {
                  setNewReply(val);
                  if (val.trim()) setReplyError('');
                }}
                cleanOnEnter={false}
                placeholder="Reply"
                inputClass="form-control" // 👈 Add this to match Bootstrap style
                shouldReturn={true} // Ensure onChange is called
                shouldConvertEmojiToImage={false} // Keep emoji as text
              />
              {replyError && <small className='text-danger'>{replyError}</small>}
            </div>

            {/* Cancel button */}
            <span
              className="cursor-pointer d-flex align-items-center ps-1"
              onClick={() => {
                setShowInput(false);
                setNewKeyword('');
                setNewReply('');
                setKeywordError('');
                setReplyError('');
              }}
            >
              <MaterialSymbol iconName='close' fontweight='200' className='fs-16' />
            </span>
          </div>
        ) : (
          <span className='new-keyword' onClick={() => handleShowInput()}>
            <MaterialSymbol iconName='add' fontweight='200' className='fs-14' /> Keyword
          </span>
        )}
      </div>
      {props.keywordsError.status && <small className='text-danger'>{props.keywordsError.message}</small>}
    </li>
  );
};

export default KeywordInput;